import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, reactive } from 'vue';

import type { CalendarState, NormalizedCalendarItem } from './calendar-state';
import * as utils from './utils';

/**
 * `CalendarItem` component props.
 */
export interface Props {
  item: NormalizedCalendarItem;
  top: string;
}

/* eslint-disable @typescript-eslint/unified-signatures */

/**
 * `CalendarItem` component emits.
 */
export interface Emits {
  (event: 'dragstart', eventData: DragEvent): void;
  (event: 'mouseenter', eventData: MouseEvent): void;
  (event: 'mouseleave', eventData: MouseEvent): void;
  (event: 'click', eventData: MouseEvent): void;
}

/* eslint-enable @typescript-eslint/unified-signatures */


const __default__ = { name: 'CalendarItem' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null,
    top: null
  },
  emits: ["dragstart", "mouseenter", "mouseleave", "click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'dragstart', eventData: DragEvent): void;
  (event: 'mouseenter', eventData: MouseEvent): void;
  (event: 'mouseleave', eventData: MouseEvent): void;
  (event: 'click', eventData: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: NormalizedCalendarItem;
  top: string;
};





const calendar = reactive(inject('calendarState') as CalendarState);

const elemAttrs = computed(() => {
  const values: Record<string, unknown> = {};

  if (calendar.enableDragDrop) {
    const title = props.item.tooltip ?? props.item.title;

    if (title) {
      values.title = title;
    }

    const ariaGrabbed = props.item === calendar.currentDragItem;

    if (ariaGrabbed) {
      values['aria-grabbed'] = ariaGrabbed;
    }

    values.draggable = true;
  }

  return values;
});

const displayTimeRange = computed(() => {
  const start = utils.formattedTime(
    props.item.startDate,
    calendar.displayLocale,
    calendar.timeFormatOptions,
  );

  let end: string | null = null;

  if (!utils.isSameDateTime(props.item.startDate, props.item.endDate)) {
    end = utils.formattedTime(
      props.item.endDate,
      calendar.displayLocale,
      calendar.timeFormatOptions,
    );
  }

  return { start, end };
});

return { __sfc: true,props, emit, calendar, elemAttrs, displayTimeRange }
}

})